import React from 'react';
interface ShowcaseLogoProps {
  tone?: 'dark' | 'light';
}
export function ShowcaseLogo({
  tone = 'dark'
}: ShowcaseLogoProps) {
  const text = tone === 'dark' ? 'text-navy' : 'text-white';
  return <span className="inline-flex flex-col leading-none" aria-label="Builders' Showcase of Homes" data-id="element-85" data-mp="wujnfzi390u3">
      <svg viewBox="0 0 160 18" className="h-3 w-[148px] text-orange" aria-hidden="true" data-id="element-86" data-mp="rux9fnufrgk8">
        <path d="M4 16 L80 3 L156 16" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-87" data-mp="45303g9bsa4q" />
      </svg>
      <span className={`mt-1 font-display text-[19px] font-bold uppercase tracking-tight ${text}`} data-id="element-88" data-mp="dwh523k1q259">
        Builders’ Showcase
      </span>
      <span className="mt-0.5 flex items-center gap-1.5" data-id="element-89" data-mp="92mceamgqcu1">
        <span className="h-[2px] flex-1 bg-orange" aria-hidden="true" data-id="element-90" data-mp="3hjh4cv1q2ctc" />
        <span className={`font-display text-[11px] font-semibold uppercase tracking-[0.28em] ${text}`} data-id="element-91" data-mp="3clpcg112uqp5">
          of Homes
        </span>
        <span className="h-[2px] flex-1 bg-orange" aria-hidden="true" data-id="element-92" data-mp="3cpesu1siblvs" />
      </span>
    </span>;
}